import { ExampleDetail } from '../models/example-detail.model';
import { Option } from '../../models/option.model';
import { ExampleMasterCondition } from '../models/example-master-condition.model';
import { ExampleMaster } from '../models/example-master.model';
import { ExampleData } from '../models/example-data.model';
import { MockService } from '../../../core/services/mock.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable, map, delay } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExampleService {

  // 測試範例為了模擬資料查詢時間，實際開發不會用到
  delay: number = 500;

  constructor(private mockService: MockService,
    private httpClient: HttpClient) { }

  queryExampleDatas(keyword: string): Observable<ExampleData[]> {
    let endpoint = `${environment.apiEndpoint}/example/keyword/` + keyword;
    endpoint = this.mockService.parseApiEndpoint(endpoint, '/api/v1/xxxxx/example/example-data.json');
    // return this.httpClient.get<ExampleData[]>(endpoint);

    // 這裡只是在模擬字少的要查詢時間比較久，用來測試如果不透過 switchMap 會發生被後回傳的資料覆蓋
    const upperCasedKeyword = keyword.toUpperCase();
    if (keyword.length == 2) {
      return this.httpClient.get<ExampleData[]>(endpoint).pipe(
        map(data => data.filter(exampleData =>
          exampleData.exampleDataCode.toUpperCase().indexOf(upperCasedKeyword) >= 0
            || exampleData.exampleDataName.toUpperCase().indexOf(upperCasedKeyword) >= 0
            || exampleData.exampleDataNameTw.toUpperCase().indexOf(upperCasedKeyword) >= 0
            || exampleData.exampleDataNameCn.toUpperCase().indexOf(upperCasedKeyword) >= 0
            || exampleData.exampleDataNameUs.toUpperCase().indexOf(upperCasedKeyword) >= 0
        )),
        delay(this.delay) // 這是故意模擬查詢資料的時間
      );
    } else {
      return this.httpClient.get<ExampleData[]>(endpoint).pipe(
        map(data => data.filter(exampleData =>
          exampleData.exampleDataCode.toUpperCase().indexOf(upperCasedKeyword) >= 0
            || exampleData.exampleDataName.toUpperCase().indexOf(upperCasedKeyword) >= 0
            || exampleData.exampleDataNameTw.toUpperCase().indexOf(upperCasedKeyword) >= 0
            || exampleData.exampleDataNameCn.toUpperCase().indexOf(upperCasedKeyword) >= 0
            || exampleData.exampleDataNameUs.toUpperCase().indexOf(upperCasedKeyword) >= 0
        ))
      );
    }
  }

  queryAllExampleDataOptions(): Observable<Option[]> {
    let endpoint = `${environment.apiEndpoint}/example/all`;
    endpoint = this.mockService.parseApiEndpoint(endpoint, '/api/v1/xxxxx/example/example-data.json');
    return this.httpClient.get<ExampleData[]>(endpoint).pipe(
      // 把 ExampleData[] 轉成 Option[]
      map(exampleDatas =>
        exampleDatas.map(exampleData => ({
          id: exampleData.exampleDataCode,
          label: exampleData.exampleDataCode + ' ' + exampleData.exampleDataName,
          value: exampleData.exampleDataCode,
          labelTw: exampleData.exampleDataCode + ' ' + exampleData.exampleDataNameTw,
          labelCn: exampleData.exampleDataCode + ' ' + exampleData.exampleDataNameCn,
          labelUs: exampleData.exampleDataCode + ' ' + exampleData.exampleDataNameUs
        }))
      ),
      delay(this.delay) // 這是故意模擬查詢資料的時間
    );
  }

  queryAllExampleDatas(): Observable<ExampleData[]> {
    let endpoint = `${environment.apiEndpoint}/example/keyword/`;
    endpoint = this.mockService.parseApiEndpoint(endpoint, '/api/v1/xxxxx/example/example-data.json');
    // return this.httpClient.get<ExampleData[]>(endpoint);
    // 這是故意模擬查詢資料的時間
    return this.httpClient.get<ExampleData[]>(endpoint).pipe(delay(3000));
  }

  queryExampleMasterDatas(condition: ExampleMasterCondition): Observable<ExampleMaster[]> {
    let endpoint = `${environment.apiEndpoint}/example-master/search/`;
    endpoint = this.mockService.parseApiEndpoint(endpoint, '/api/v1/xxxxx/example/example-master.json');
    // return this.httpClient.get<ExampleMaster[]>(endpoint);

    // 因為沒有真的後端程式，這裡是模擬後端查詢篩選資料
    return this.httpClient.get<ExampleMaster[]>(endpoint).pipe(
      map(data => data.filter(exampleMaster =>
        (!condition.input || (condition.input && exampleMaster.input?.toUpperCase() == condition.input.toUpperCase()))
        && (!condition.calendar || (condition.calendar && exampleMaster.calendar?.toUpperCase() == condition.calendar.toUpperCase()))
        && (!condition.dropdown || (condition.dropdown && exampleMaster.dropdown?.toUpperCase() == condition.dropdown.toUpperCase()))
        && (!condition.autoCompleteCode || (condition.autoCompleteCode && exampleMaster.autoCompleteCode?.toUpperCase() == condition.autoCompleteCode.toUpperCase()))
        && (!condition.inputNumber || (condition.inputNumber && exampleMaster.inputNumber == condition.inputNumber))
        && (!condition.custValidation || (condition.custValidation && exampleMaster.custValidation?.toUpperCase() == condition.custValidation.toUpperCase()))
        && (!condition.dynamicDropdown || (condition.dynamicDropdown && exampleMaster.dynamicDropdown?.toUpperCase() == condition.dynamicDropdown.toUpperCase()))
        && (!condition.autoCompleteDropdownCode || (condition.autoCompleteDropdownCode && exampleMaster.autoCompleteDropdownCode?.toUpperCase() == condition.autoCompleteDropdownCode.toUpperCase()))
      )),
      delay(this.delay) // 這是故意模擬查詢資料的時間
    );
  }

  getExampleMasterData(uuid: string): Observable<ExampleMaster> {
    let endpoint = `${environment.apiEndpoint}/example-master/uuid/` + uuid;
    endpoint = this.mockService.parseApiEndpoint(endpoint, '/api/v1/xxxxx/example/example-master.json');
    // return this.httpClient.get<ExampleData[]>(endpoint);

    // 因為沒有真的後端程式，這裡是模擬後端查詢篩選資料
    return this.httpClient.get<ExampleMaster[]>(endpoint).pipe(
      map(data => data.find(exampleMaster => exampleMaster.uuid == uuid)!),
      delay(this.delay) // 這是故意模擬查詢資料的時間
    );
  }

  /**
   * 這裡應該傳 parentUuid 去查，因為傳 id 隨便人都可以改數字就抓到資料，
   * 這裡傳 id 只是因為我沒有後端程式可以處理，只是為了做取值範例
   */
  getExampleDetailData(parentId: string): Observable<ExampleDetail[]> {
    let endpoint = `${environment.apiEndpoint}/example-detail/id/` + parentId;
    endpoint = this.mockService.parseApiEndpoint(endpoint, '/api/v1/xxxxx/example/example-detail.json');
    // return this.httpClient.get<ExampleData[]>(endpoint);

    // 因為沒有真的後端程式，這裡是模擬後端查詢篩選資料
    return this.httpClient.get<ExampleDetail[]>(endpoint).pipe(
      map(data => data.filter(exampleDetail => exampleDetail.parentId == parentId)!),
      delay(this.delay) // 這是故意模擬查詢資料的時間
    );
  }
}
